/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_Live_StopInputs */

const vi_fleet_camera_live_stop = /** @type {(inputs: Fleet_Camera_Live_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dừng trực tiếp`)
};

/**

* @param {Fleet_Camera_Live_StopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_live_stop = /** @type {((inputs?: Fleet_Camera_Live_StopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_Live_StopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_live_stop(inputs)
});